import React, { useEffect, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastContext';
import { mensajeAmigable } from '../utils/errores';
import { obtenerServicios, actualizarServicio, eliminarServicio } from '../services/serviciosService';
import { obtenerNegocio } from '../services/negociosService';
import { copiarTexto } from '../utils/compartir';
import { etiquetaPrecio, etiquetaDuracion, MODALIDADES_SERVICIO } from '../utils/servicios';
import FormularioNuevoServicio from './FormularioNuevoServicio';
import FrasesRapidasModal from './FrasesRapidasModal';
import { optimizarFoto } from '../utils/imagen';

const P = 'var(--color-primario,#DB2777)';

function iconoModalidad(clave) {
  return (MODALIDADES_SERVICIO.find((m) => m.clave === clave) || {}).icono || '🧰';
}

export default function ServiciosView({ onVolver }) {
  const { negocio, puede } = useAuth();
  const esVendedora = !puede('servicios'); // sin permiso "Administrar servicios": solo ve y comparte
  const { mostrarToast } = useToast();
  const moneda = negocio?.moneda || 'L';
  const [servicios, setServicios] = useState(null);
  const [error, setError] = useState(null);
  const [busqueda, setBusqueda] = useState('');
  const [soloActivos, setSoloActivos] = useState(false);
  const [form, setForm] = useState(null); // null | { servicio? }  → abre el modal
  const [mostrarFrases, setMostrarFrases] = useState(false);

  const cargar = async () => {
    setError(null);
    try { setServicios(await obtenerServicios()); }
    catch (e) { setError(mensajeAmigable(e)); }
  };
  useEffect(() => { cargar(); }, []);

  const toggleActivo = async (s) => {
    try {
      await actualizarServicio(s.id, { activo: !s.activo });
      setServicios((prev) => prev.map((x) => x.id === s.id ? { ...x, activo: !s.activo } : x));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  // Comparte el catálogo público de servicios (requiere nombre corto + catálogo público).
  const compartirCatalogo = async () => {
    try {
      const n = await obtenerNegocio();
      if (!n?.slug) { mostrarToast('Primero pon tu "nombre corto" (slug) en Configuración.', 'error', 6000); return; }
      if (!n?.catalogo_publico) { mostrarToast('Activa tu catálogo público en Configuración para poder compartirlo.', 'error', 6000); return; }
      const url = `${window.location.origin}/sc/${n.slug}`;
      const ok = await copiarTexto(url);
      mostrarToast(ok ? '🔗 Enlace del catálogo copiado. Pégalo en WhatsApp o Instagram.' : url, ok ? 'exito' : 'info');
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const borrar = async (s) => {
    if (!window.confirm(`¿Eliminar el servicio "${s.nombre}"? No se puede deshacer.`)) return;
    try {
      await eliminarServicio(s);
      mostrarToast('Servicio eliminado 🗑️', 'exito');
      setServicios((prev) => prev.filter((x) => x.id !== s.id));
    } catch (e) { mostrarToast(mensajeAmigable(e), 'error'); }
  };

  const texto = busqueda.trim().toLowerCase();
  const filtrados = (servicios || [])
    .filter((s) => !soloActivos || s.activo)
    .filter((s) => !texto
      || (s.nombre || '').toLowerCase().includes(texto)
      || (s.codigo || '').toLowerCase().includes(texto)
      || (s.categoria || '').toLowerCase().includes(texto));

  return (
    <div className="k-page">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
        <h2 className="k-page-title">🧰 Servicios</h2>
        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
          <button onClick={compartirCatalogo} className="k-btn-soft" title="Comparte tu catálogo de servicios con clientes">🔗 Compartir catálogo</button>
          {!esVendedora && <button onClick={() => setMostrarFrases(true)} className="k-btn-soft" title="Configurá tus frases (incluye / no incluye / requisitos) y adicionales frecuentes">📋 Frases y adicionales</button>}
          {!esVendedora && <button onClick={() => setForm({})} style={{ padding: '10px 18px', background: P, color: '#fff', border: 'none', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Nuevo servicio</button>}
          <button onClick={onVolver} className="k-btn-soft">← Volver</button>
        </div>
      </div>

      {servicios && servicios.length > 0 && (
        <div style={{ display: 'flex', gap: '8px', marginBottom: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
          <input type="search" value={busqueda} onChange={(e) => setBusqueda(e.target.value)}
            placeholder="🔍 Buscar por nombre, código o categoría"
            style={{ flex: 1, minWidth: '200px', padding: '10px', border: '1px solid #D1D5DB', borderRadius: '8px', fontSize: '14px', background: '#fff' }} />
          <label style={{ fontSize: '13px', color: '#374151', display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}>
            <input type="checkbox" checked={soloActivos} onChange={(e) => setSoloActivos(e.target.checked)} /> Solo activos
          </label>
        </div>
      )}

      {!servicios && !error && <div style={{ textAlign: 'center', padding: '32px', color: '#6B7280' }}>⏳ Cargando servicios…</div>}
      {error && <p style={{ textAlign: 'center', padding: '24px', color: '#991B1B', fontWeight: 600 }}>⚠️ {error}</p>}
      {servicios && servicios.length === 0 && (
        <div style={{ textAlign: 'center', padding: '40px 16px', color: '#6B7280' }}>
          <div style={{ fontSize: '46px' }}>🧰</div>
          <p style={{ fontWeight: 700, color: '#111827', margin: '8px 0 4px' }}>Aún no tienes servicios</p>
          <p style={{ fontSize: '14px', margin: '0 0 16px' }}>Crea tu primer servicio para cotizarlo y compartirlo con tus clientes.</p>
          {!esVendedora && <button onClick={() => setForm({})} style={{ padding: '12px 22px', background: P, color: '#fff', border: 'none', borderRadius: '10px', fontWeight: 'bold', cursor: 'pointer' }}>➕ Crear mi primer servicio</button>}
        </div>
      )}

      {filtrados.length > 0 && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(260px, 1fr))', gap: '12px' }}>
          {filtrados.map((s) => {
            const foto = s[`foto_${s.foto_principal || 1}_url`] || s.foto_1_url;
            return (
              <div key={s.id} className="k-card" style={{ overflow: 'hidden', display: 'flex', flexDirection: 'column', opacity: s.activo ? 1 : 0.6 }}>
                <div style={{ height: '130px', background: '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative' }}>
                  {foto ? <img src={optimizarFoto(foto, 500)} alt={s.nombre} loading="lazy" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        : <span style={{ fontSize: '40px' }}>{iconoModalidad(s.modalidad_servicio)}</span>}
                  {s.destacado && <span style={{ position: 'absolute', top: '8px', left: '8px', background: '#FBBF24', color: '#78350F', fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '999px' }}>★ Destacado</span>}
                  {!s.activo && <span style={{ position: 'absolute', top: '8px', right: '8px', background: '#6B7280', color: '#fff', fontSize: '11px', fontWeight: 700, padding: '2px 8px', borderRadius: '999px' }}>Inactivo</span>}
                </div>
                <div style={{ padding: '12px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                  {s.codigo && <span style={{ fontSize: '11px', color: '#9CA3AF', fontWeight: 600 }}>{s.codigo}</span>}
                  <p style={{ margin: '2px 0 4px', fontWeight: 700, color: '#111827', fontSize: '14.5px' }}>{s.nombre}</p>
                  {s.descripcion_corta && <p style={{ margin: '0 0 6px', fontSize: '12.5px', color: '#6B7280', lineHeight: 1.35 }}>{s.descripcion_corta}</p>}
                  <p style={{ margin: '0 0 2px', fontWeight: 700, color: P, fontSize: '14px' }}>{etiquetaPrecio(s, moneda)}</p>
                  <p style={{ margin: 0, fontSize: '12px', color: '#9CA3AF' }}>
                    {iconoModalidad(s.modalidad_servicio)} {(MODALIDADES_SERVICIO.find((m) => m.clave === s.modalidad_servicio) || {}).nombre}
                    {etiquetaDuracion(s) ? ` · ⏱️ ${etiquetaDuracion(s)}` : ''}
                  </p>
                  {!esVendedora && <div style={{ display: 'flex', gap: '6px', marginTop: '10px', flexWrap: 'wrap' }}>
                    <button onClick={() => setForm({ servicio: s })} style={{ padding: '5px 10px', background: '#EEF2FF', color: '#4338CA', border: 'none', borderRadius: '6px', fontSize: '12px', fontWeight: 700, cursor: 'pointer' }}>✏️ Editar</button>
                    <button onClick={() => toggleActivo(s)} style={{ padding: '5px 10px', background: 'none', border: '1px solid #D1D5DB', borderRadius: '6px', fontSize: '12px', cursor: 'pointer' }}>{s.activo ? '⏸️ Desactivar' : '▶️ Activar'}</button>
                    <button onClick={() => borrar(s)} style={{ padding: '5px 10px', background: 'none', border: '1px solid #FCA5A5', borderRadius: '6px', fontSize: '12px', color: '#DC2626', cursor: 'pointer' }}>🗑️</button>
                  </div>}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {form && (
        <FormularioNuevoServicio
          servicio={form.servicio || null}
          onCerrar={() => setForm(null)}
          onGuardado={cargar}
        />
      )}

      {mostrarFrases && <FrasesRapidasModal onCerrar={() => setMostrarFrases(false)} />}
    </div>
  );
}
